import { useState } from "react";

const dealers = ["Teknoloji Dünyası", "Bilgisayar Plaza", "Ofis Market", "Ana Bayi"];
const statuses = ["Bekliyor", "Onaylandı", "Reddedildi", "Süresi Doldu"];

const allData = [
  { date: "2026-07-17", offerNo: "T-2026-045", product: "Gaming Laptop", brand: "MSI", qty: 5, unitPrice: 18500, total: 92500, dealer: "Teknoloji Dünyası", status: "Bekliyor", validUntil: "2026-07-24" },
  { date: "2026-07-16", offerNo: "T-2026-044", product: "27\" Monitör", brand: "Samsung", qty: 10, unitPrice: 3200, total: 32000, dealer: "Bilgisayar Plaza", status: "Onaylandı", validUntil: "2026-07-23" },
  { date: "2026-07-15", offerNo: "T-2026-043", product: "USB-C Hub", brand: "Dell", qty: 50, unitPrice: 280, total: 14000, dealer: "Ofis Market", status: "Reddedildi", validUntil: "2026-07-22" },
  { date: "2026-07-14", offerNo: "T-2026-042", product: "Mechanik Klavye", brand: "Corsair", qty: 20, unitPrice: 1100, total: 22000, dealer: "Ana Bayi", status: "Bekliyor", validUntil: "2026-07-21" },
  { date: "2026-07-13", offerNo: "T-2026-041", product: "Webcam 4K", brand: "Logitech", qty: 8, unitPrice: 1200, total: 9600, dealer: "Teknoloji Dünyası", status: "Süresi Doldu", validUntil: "2026-07-20" },
  { date: "2026-07-12", offerNo: "T-2026-040", product: "Tablet 10\"", brand: "Apple", qty: 15, unitPrice: 8500, total: 127500, dealer: "Bilgisayar Plaza", status: "Onaylandı", validUntil: "2026-07-19" },
];

export default function OffersReport() {
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [status, setStatus] = useState("");
  const [dealer, setDealer] = useState("");
  const [search, setSearch] = useState("");

  const data = allData.filter((i) => {
    if (startDate && i.date < startDate) return false;
    if (endDate && i.date > endDate) return false;
    if (status && i.status !== status) return false;
    if (dealer && i.dealer !== dealer) return false;
    if (search && !i.product.toLowerCase().includes(search.toLowerCase())) return false;
    return true;
  });

  const statusColors: Record<string, string> = {
    "Bekliyor": "bg-primary-100 text-primary-700",
    "Onaylandı": "bg-secondary-100 text-secondary-700",
    "Reddedildi": "bg-accent-100 text-accent-700",
    "Süresi Doldu": "bg-foreground-100 text-foreground-600",
  };

  return (
    <div className="space-y-4">
      <div className="bg-background-50 border border-background-200/70 rounded-xl overflow-hidden">
        <div className="bg-secondary-400 px-4 py-3 flex items-center justify-between">
          <span className="text-sm font-semibold text-background-50">Teklifler Rapor Kriterleri</span>
          <button onClick={() => { setStartDate(""); setEndDate(""); setStatus(""); setDealer(""); setSearch(""); }} className="text-xs text-background-50/80 hover:text-background-50 transition-colors cursor-pointer">Temizle</button>
        </div>
        <div className="p-4 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          <div className="sm:col-span-2">
            <label className="block text-xs font-medium text-foreground-600 mb-1">Tarih Aralığı</label>
            <div className="flex items-center gap-2">
              <input type="date" value={startDate} onChange={(e) => setStartDate(e.target.value)} className="flex-1 px-3 py-2 bg-background-100 border border-background-200/70 rounded-lg text-sm text-foreground-950 focus:outline-none focus:ring-2 focus:ring-secondary-400" />
              <span className="text-sm text-foreground-400">-</span>
              <input type="date" value={endDate} onChange={(e) => setEndDate(e.target.value)} className="flex-1 px-3 py-2 bg-background-100 border border-background-200/70 rounded-lg text-sm text-foreground-950 focus:outline-none focus:ring-2 focus:ring-secondary-400" />
            </div>
          </div>
          <div>
            <label className="block text-xs font-medium text-foreground-600 mb-1">Durum</label>
            <select value={status} onChange={(e) => setStatus(e.target.value)} className="w-full px-3 py-2 bg-background-100 border border-background-200/70 rounded-lg text-sm text-foreground-950 focus:outline-none focus:ring-2 focus:ring-secondary-400 cursor-pointer">
              <option value="">Tümü</option>
              {statuses.map((s) => <option key={s} value={s}>{s}</option>)}
            </select>
          </div>
          <div>
            <label className="block text-xs font-medium text-foreground-600 mb-1">Cari Bayi</label>
            <select value={dealer} onChange={(e) => setDealer(e.target.value)} className="w-full px-3 py-2 bg-background-100 border border-background-200/70 rounded-lg text-sm text-foreground-950 focus:outline-none focus:ring-2 focus:ring-secondary-400 cursor-pointer">
              <option value="">Tümü</option>
              {dealers.map((d) => <option key={d} value={d}>{d}</option>)}
            </select>
          </div>
          <div className="sm:col-span-2 lg:col-span-2">
            <label className="block text-xs font-medium text-foreground-600 mb-1">Ürün Ara</label>
            <div className="relative">
              <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400"></i>
              <input type="text" placeholder="Ara..." value={search} onChange={(e) => setSearch(e.target.value)} className="w-full pl-9 pr-3 py-2 bg-background-100 border border-background-200/70 rounded-lg text-sm text-foreground-950 focus:outline-none focus:ring-2 focus:ring-secondary-400" />
            </div>
          </div>
        </div>
      </div>

      <div className="flex items-center justify-between">
        <h2 className="text-lg font-semibold text-foreground-950">Teklif Listesi</h2>
        <span className="text-sm text-foreground-500">{data.length} teklif</span>
      </div>

      <div className="hidden lg:block bg-background-50 border border-background-200/70 rounded-xl overflow-hidden">
        <table className="w-full text-sm">
          <thead>
            <tr className="bg-background-100 border-b border-background-200/70">
              <th className="px-4 py-3 text-left font-medium text-foreground-600">Teklif No</th>
              <th className="px-4 py-3 text-left font-medium text-foreground-600">Tarih</th>
              <th className="px-4 py-3 text-left font-medium text-foreground-600">Ürün</th>
              <th className="px-4 py-3 text-left font-medium text-foreground-600">Marka</th>
              <th className="px-4 py-3 text-center font-medium text-foreground-600">Adet</th>
              <th className="px-4 py-3 text-right font-medium text-foreground-600">Birim</th>
              <th className="px-4 py-3 text-right font-medium text-foreground-600">Toplam</th>
              <th className="px-4 py-3 text-center font-medium text-foreground-600">Durum</th>
              <th className="px-4 py-3 text-left font-medium text-foreground-600">Bayi</th>
            </tr>
          </thead>
          <tbody>
            {data.map((item, idx) => (
              <tr key={idx} className="border-b border-background-200/50 hover:bg-background-100/50 transition-colors">
                <td className="px-4 py-3 text-foreground-500">{item.offerNo}</td>
                <td className="px-4 py-3 text-foreground-500">{item.date}</td>
                <td className="px-4 py-3 font-medium text-foreground-900">{item.product}</td>
                <td className="px-4 py-3 text-foreground-500">{item.brand}</td>
                <td className="px-4 py-3 text-center text-foreground-900">{item.qty}</td>
                <td className="px-4 py-3 text-right text-foreground-500">${item.unitPrice.toLocaleString("en-US")}</td>
                <td className="px-4 py-3 text-right font-semibold text-foreground-900">${item.total.toLocaleString("en-US")}</td>
                <td className="px-4 py-3 text-center">
                  <span className={`inline-flex px-2 py-0.5 rounded-full text-xs font-medium ${statusColors[item.status] || "bg-background-100 text-foreground-600"}`}>{item.status}</span>
                </td>
                <td className="px-4 py-3 text-foreground-500">{item.dealer}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="lg:hidden space-y-3">
        {data.map((item, idx) => (
          <div key={idx} className="bg-background-50 border border-background-200/70 rounded-xl p-4">
            <div className="flex items-start justify-between">
              <div>
                <p className="text-sm font-medium text-foreground-900">{item.product}</p>
                <p className="text-xs text-foreground-400">{item.offerNo} · {item.date}</p>
              </div>
              <span className={`inline-flex px-2 py-0.5 rounded-full text-xs font-medium shrink-0 ${statusColors[item.status] || "bg-background-100 text-foreground-600"}`}>{item.status}</span>
            </div>
            <div className="flex items-center justify-between mt-2">
              <p className="text-xs text-foreground-500">{item.qty} adet · {item.dealer}</p>
              <p className="text-sm font-bold text-foreground-900">${item.total.toLocaleString("en-US")}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}